import React, { useState } from 'react';
import { useEffect } from 'react';
import { TextField, Select, MenuItem, FormControl, InputLabel, Typography, Grid, CircularProgress } from '@mui/material';
import { Card, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import Button from '@mui/material/Button';
import ComponentHeaderTitles from '../../../ComponentHeaderTitles';

const StyledCard = styled(Card)({
    marginBottom: "1rem",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
    cursor: "pointer",
    "&.selected": {
        backgroundColor: "#f0f0f0",
    },
});


const ParticulierVerbruikEstimaterStep1 = ({ chosenPersons, setPersonen, onValidationChange }) => {
    console.log(chosenPersons);
    const BACKEND_URL = "https://offerte.api.cleanenergy.nl/estimate.php";
    // set the state to previously chosen amount persons, or to 1 (the first option) if no option was chosen yet
    const [personen, setSelectedPersons] = useState(chosenPersons ? chosenPersons : '1');
    const validateStepOne = (personen) => {
        if (personen === "") {
            return [false, 'Selecteer het aantal personen'];
        }
        return [true, null];
    };


    // When the component mounts, we check if chosenPersons has a value.
    // If it doesn't, we call setPersonen with the default value.
    useEffect(() => {
        if (!chosenPersons) {
            setPersonen(personen);
        }
    }, []); // Empty dependency array to ensure this only runs on mount

    const handleCardClick = (value) => {
        setSelectedPersons(value);
        setPersonen(value);
        const [personenIsValid, personenErrorMessage] = validateStepOne(value);
        onValidationChange({
            isValid: personenIsValid,
            errorMessage: personenErrorMessage
        });
    };

    const personenOptions = [
        { value: '1', label: '1 persoon' },
        { value: '2', label: '2 personen' },
        { value: '3', label: '3 personen' },
        { value: '4', label: '4 personen' },
        { value: '5', label: '5 of meer' },
    ];

    return (
        <div>
            <ComponentHeaderTitles title="Uit hoeveel personen bestaat je huishouden?"/>
            <FormControl component="fieldset" className='steps-rows'>
                <RadioGroup
                    aria-label="personen"
                    name="personen"
                    value={personen}
                    onChange={(e) => handleCardClick(e.target.value)}
                >
                    {personenOptions.map((option) => (
                        <StyledCard
                            key={option.value}
                            onClick={() => handleCardClick(option.value)}
                            className={personen === option.value ? "selected" : ""}
                        >
                            <CardContent>
                                <FormControlLabel
                                    value={option.value}
                                    control={<Radio />}
                                    label={
                                        <div className="icon-text-wrapper">
                                            {/* Voeg de specifieke icoon toe als die er is, bijvoorbeeld: */}
                                            <div className={`icon-as-${option.value}pers icon-size`}></div>
                                            <Typography variant="h5" component="h2">
                                                {option.label}
                                            </Typography>
                                        </div>
                                    }
                                />
                            </CardContent>
                        </StyledCard>
                    ))}
                </RadioGroup>
            </FormControl>
        </div>
    );
};


ParticulierVerbruikEstimaterStep1.displayName = 'ParticulierVerbruikEstimaterStep1';
export default ParticulierVerbruikEstimaterStep1;
